import axios from 'axios';
import { attachRequestContext } from '../common/attachRequestContext';

export type ContactCategory = 'bug' | 'feedback' | 'other';

export type ContactPayload = {
  email: string;
  category: ContactCategory;
  message: string;
  pageUrl?: string;
};

const contactClient = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL ?? '',
});

attachRequestContext(contactClient);

async function readContactError(error: unknown, fallback: string): Promise<string> {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.error;
    if (typeof message === 'string') {
      return message;
    }
  }
  return fallback;
}

export async function submitContactForm(payload: ContactPayload): Promise<void> {
  try {
    await contactClient.post('/contact', payload);
  } catch (error) {
    throw new Error(
      await readContactError(error, 'Unable to send your message. Please try again.'),
    );
  }
}
